module.exports = __webpack_public_path__ + "media/images/pic01-b9a9c81763e5f6e1a4921eefcb5dd626.jpg";